module.exports = __webpack_public_path__ + "img/zuzhi.be207bfa.png";